import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Box, Button, Typography } from '@mui/material';

import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';

type PropTypes = {
  onClose: () => void;
  isOpen: boolean;
  upload: (arg0: HTMLInputElement | null) => void;
  titleId?: string;
  bodyElement?: React.ReactNode;
}

const FileUploadDialog: React.FC<PropTypes> = (props: PropTypes) => {
  const {
    onClose, isOpen, upload, titleId, bodyElement,
  } = props;
  const file = useRef<HTMLInputElement>(null);
  return (
    <GenericDialog
      isOpen={isOpen}
    >
      <ContentBox title={<FormattedMessage id={titleId || 'genericUploadFile'} />}>
        <Typography sx={{ my: 1 }}>
          <FormattedMessage id="trialmanagement.fileUploadDialogDescription" />
        </Typography>
        <Box>
          {bodyElement}
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography>
            <input style={{ flexGrow: 1 }} type="file" ref={file} />
          </Typography>
          <Box>
            <Button
              sx={{ mx: 0.5 }}
              variant="contained"
              onClick={() => upload(file.current)}
              color="primary"
            >
              <FormattedMessage id="trialmanagement.uploadButton" />
            </Button>
            <Button
              sx={{ mx: 0.5 }}
              variant="contained"
              onClick={onClose}
              color="secondary"
            >
              <FormattedMessage id="genericClose" />
            </Button>
          </Box>
        </Box>
      </ContentBox>
    </GenericDialog>
  );
};

export default FileUploadDialog;
